import React, { useContext } from "react";
import t from "Utils/translation";
import { MediaQueriesContext } from "../../App";
import s from "./showInfoButton.scss";

// works with pages title container
const ShowInfoButton = ({ onClick = () => {}, isInfoOpen = false }) => {
  const { isMediaMobile } = useContext(MediaQueriesContext);

  return isMediaMobile ? (
    <div onClick={onClick} className={s.showInfoButton}>
      {isInfoOpen ? t("button.details.hide") : t("button.details.show")}
    </div>
  ) : null;
};

export default ShowInfoButton;
